import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
  key: 'ireg',
  storage: window.localStorage,
  modules: ['app', 'auth'],
})

Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  plugins: [vuexLocal.plugin],
})
